import { css } from '@emotion/react'
import styled from '@emotion/styled'

// generate dynamic styles based on props
const generateExclusionStyles = ({ excluded, theme, spacing }) => {
  if (!excluded || excluded.length === 0) return ''

  return css`
    > * + *${excluded.map((item) => `:not(${item})`).join('')} {
      margin-top: ${theme.spacing[spacing]};
    }
  `
}

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ alignMainContent }) =>
    alignMainContent?.toLowerCase() === 'center' ? 'center' : 'flex-start'};
  position: inherit;

  ${({ excluded, theme, spacing }) =>
    generateExclusionStyles({ excluded, theme, spacing })}
  // position must be set to 'inherit,' otherwise the Stack component
  // gets pushed behind the background image if a background image is
  // set to a parent variableContent component in Contentful
  position: inherit;

  > * + *${({ excluded }) => excluded.map((item) => `:not(${item})`)} {
    margin-top: ${({ theme, spacing }) => theme.spacing[spacing]};
  }

  .leshen-package-card {
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    height: 100%;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`
